module.exports = __webpack_public_path__ + "img/get-conected.5a591d45.jpg";